import React from "react";

const Footer = () => {
  const now = new Date().getFullYear()
  return (
    <footer style={{ padding: "20px 0", textAlign: "center" }}>
      <p>
        Copyright © Designed & Developed by{" "}
        <a href="https://triplewsols.org" target="_blank" rel="noreferrer">
          3W
        </a>{" "}
        {now}
      </p>
    </footer>
  );
};

export default Footer;
